/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */

import { createAsyncThunk } from '@reduxjs/toolkit';
import { apiInstance } from '../../Apis/Axios';
import apiInstanceV2 from '../../Apis/AxiosV2';
import { SYSTEM_CONFIG_SERVICE } from '../EndPoints';

/**
 * GetFirstSystemConfig
 *
 * Async thunk to fetch the initial system configuration from the backend.
 * Uses Axios instance V2 and handles both success and error responses.
 *
 * @returns {Object} An object containing the response data and status code.
 */
export const GetFirstSystemConfig = createAsyncThunk(
    'systemConfig/getFirstSystemConfig',
    async () => {
        const result = await apiInstanceV2
            .get(SYSTEM_CONFIG_SERVICE.getFirstSystemConfig) // Make GET request to fetch config
            .then(function (response) {
                return response; // On success, return the response
            })
            .catch(function (error) {
                return error.response; // On failure, return the error response
            });

        const { data, status } = result;
        return { data, status }; // Return structured payload
    }
);

/**
 * GetTolerances
 *
 * Async thunk to fetch the access tolerance configuration from the backend.
 * Uses Axios instance V2 and handles both success and error responses.
 *
 * @returns {Object} An object containing the response data and status code.
 */
export const GetTolerances = createAsyncThunk(
    'systemConfig/getTolerances',
    async () => {
        const result = await apiInstanceV2
            .get(SYSTEM_CONFIG_SERVICE.getTolerances) // Make GET request to fetch tolerances
            .then(function (response) {
                return response; // On success, return the response
            })
            .catch(function (error) {
                return error.response; // On failure, return the error response
            });

        const { data, status } = result;
        return { data, status }; // Return structured payload
    }
);

/**
 * PartialUpdateSystemConfig
 *
 * Async thunk to partially update the system configuration.
 * Sends the provided body payload using Axios instance V1.
 *
 * @param {Object} body - The updated configuration data to be sent to the backend.
 * @param {Object} thunkAPI - Contains dispatch and getState from Redux Toolkit.
 *
 * @returns {Object} An object containing the response data and status code.
 */
export const PartialUpdateSystemConfig = createAsyncThunk(
    'systemConfig/partialUpdateSystemConfig',
    async (body, { dispatch, getState }) => {
        const result = await apiInstance
            .put(SYSTEM_CONFIG_SERVICE.partialUpdateSystemConfig, body) // Make PUT request to update config
            .then(function (response) {
                return response; // On success, return the response
            })
            .catch(function (error) {
                return error.response; // On failure, return the error response
            });

        const { data, status } = result;
        return { data, status }; // Return structured payload
    }
);
